export const EVENTS = {
  HANDLE_CONNECT: "handleConnect",
  HANDLE_DISCONNECT: "handleDisconnect",
  HANDLE_STAKE: "handleStake",
  HANDLE_UNSTAKE: "handleUnstake",
  HANDLE_CLAIM: "handleClaim",
  HANDLE_ERC20_APPROVE: "handleTokenApprove",
  HANDLE_XTOKEN_APPROVE: "handleXTokenApprove",
  OPEN_WALLET_MODAL: "openWalletModal",
  SWITCH_NETWORK: "switchnetwork",
  HANDLE_VAULT_DEPOSIT: "handleVaultDeposit",
  HANDLE_VAULT_WITHDRAW: "handleVaultWithdraw",
  HANDLE_VAULT_APPROVE: "handleVaultApprove",
  HANDLE_VAULT_XTOKEN_APPROVE: "handleVaultXTokenApprove",
  HANDLE_VAULT_CLAIM: "handleVaultClaim",
  HANDLE_YIELD_VAULT_DEPOSIT: "handleYieldVaultDeposit",
  HANDLE_YIELD_VAULT_WITHDRAW: "handleYieldVaultWithdraw",
  HANDLE_YIELD_VAULT_APPROVE: "handleYieldVaultApprove",
  HANDLE_STABLE_VAULT_DEPOSIT: "handleStableVaultDeposit",
  HANDLE_STABLE_VAULT_WITHDRAW: "handleStableVaultWithdraw",
  HANDLE_STABLE_VAULT_APPROVE: "handleStableVaultApprove",
  HANDLE_STABLE_VAULT_XTOKEN_APPROVE: "handleStableVaultXTokenApprove",
  HANDLE_STABLE_VAULT_CLAIM: "handleStableVaultClaim",
  HANDLE_STABLE_VAULT_REQUEST_REDEEM: "handleStableVaultRequestRedeem",
  HANDLE_STABLE_VAULT_REDEEM_ASSET: "handleStableVaultRedeemAsset",
  HANDLE_YIELD_VAULT_XTOKEN_APPROVE: "handleYieldVaultXTokenApprove",
  HANDLE_YIELD_VAULT_CLAIM: "handleYieldVaultClaim",
  HANDLE_UNSTAKE_GAIN_OPP: "handleUnstakeGainOpportunities",
  HANDLE_CRYPTANIUM_VAULT_DEPOSIT: "handleCryptaniumVaultDeposit",
  HANDLE_CRYPTANIUM_VAULT_WITHDRAW: "handleCryptaniumVaultWithdraw",
  HANDLE_CRYPTANIUM_VAULT_APPROVE: "handleCryptaniumVaultApprove",
  HANDLE_CRYPTANIUM_VAULT_XTOKEN_APPROVE: "handleCryptaniumVaultXTokenApprove",
  HANDLE_CRYPTANIUM_VAULT_CLAIM: "handleCryptaniumVaultClaim",
  HANDLE_CRYPTANIUM_VAULT_REQUEST_REDEEM: "handleCryptaniumVaultRequestRedeem",
  HANDLE_CRYPTANIUM_VAULT_REDEEM_ASSET: "handleCryptaniumVaultRedeemAsset",
};
